/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommonErrorBadGateway } from '../models';
// @ts-ignore
import type { CommonErrorBadRequest } from '../models';
// @ts-ignore
import type { CommonErrorGatewayTimeout } from '../models';
// @ts-ignore
import type { CommonErrorInternalServerError } from '../models';
// @ts-ignore
import type { CommonErrorNotFound } from '../models';
// @ts-ignore
import type { CommonErrorPayloadTooLarge } from '../models';
// @ts-ignore
import type { CommonErrorUnauthorized } from '../models';
// @ts-ignore
import type { CommonErrorUnsupportedMediaType } from '../models';
// @ts-ignore
import type { FormulaCalculationResponse } from '../models';
// @ts-ignore
import type { WasteManagementRequest } from '../models';
/**
 * CalculationServiceWasteManagementApi - axios parameter creator
 */
export const CalculationServiceWasteManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate waste management emissions
         * @param {WasteManagementRequest} wasteManagementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wasteManagement: async (wasteManagementRequest: WasteManagementRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wasteManagementRequest' is not null or undefined
            assertParamExists('wasteManagement', 'wasteManagementRequest', wasteManagementRequest)
            const localVarPath = `/calculation/v1/calculate/waste-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(wasteManagementRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationServiceWasteManagementApi - functional programming interface
 */
export const CalculationServiceWasteManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalculationServiceWasteManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Calculate waste management emissions
         * @param {WasteManagementRequest} wasteManagementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wasteManagement(wasteManagementRequest: WasteManagementRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wasteManagement(wasteManagementRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceWasteManagementApi.wasteManagement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalculationServiceWasteManagementApi - factory interface
 */
export const CalculationServiceWasteManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalculationServiceWasteManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary Calculate waste management emissions
         * @param {CalculationServiceWasteManagementApiWasteManagementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wasteManagement(requestParameters: CalculationServiceWasteManagementApiWasteManagementRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.wasteManagement(requestParameters.wasteManagementRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for wasteManagement operation in CalculationServiceWasteManagementApi.
 */
export interface CalculationServiceWasteManagementApiWasteManagementRequest {
    readonly wasteManagementRequest: WasteManagementRequest
}

/**
 * CalculationServiceWasteManagementApi - object-oriented interface
 */
export class CalculationServiceWasteManagementApi extends BaseAPI {
    /**
     * 
     * @summary Calculate waste management emissions
     * @param {CalculationServiceWasteManagementApiWasteManagementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public wasteManagement(requestParameters: CalculationServiceWasteManagementApiWasteManagementRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceWasteManagementApiFp(this.configuration).wasteManagement(requestParameters.wasteManagementRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

